import { z } from "zod";
import { commonSchemas } from "../common";

// Feature-specific validation schemas
export const featureSchemas = {
  // Authentication schemas
  auth: {
    // Login form
    login: z.object({
      email: commonSchemas.email,
      password: commonSchemas.text(1, 100), // Don't expose password requirements
    }),

    // Registration form
    register: z
      .object({
        nickname: commonSchemas.text(2, 50),
        email: commonSchemas.email,
        password: commonSchemas.password,
        confirmPassword: commonSchemas.text(1, 100),
      })
      .refine((data) => data.password === data.confirmPassword, {
        message: "Passwords don't match",
        path: ["confirmPassword"],
      }),
  },

  // User profile schemas
  profile: {
    reportsFilter: z.object({
      timeRange: z.enum(["today", "7_days", "30_days", "90_days", "1_year"]),
      viewType: z.enum(["total_price", "bv", "sv"]),
      currency: z.enum(["uvm", "usdt"]),
      productType: z.enum(["all", "products", "services"]), // "nfts" disabled until NFT support is ready
    }),

    // User profile form
    userProfile: z.object({
      nickname: commonSchemas.text(2, 50),
      email: commonSchemas.email,
      bio: commonSchemas.optionalText(500),
      website: commonSchemas.url.optional(),
    }),

    // Contact form
    contact: z.object({
      name: commonSchemas.text(2, 100),
      email: commonSchemas.email,
      phone: commonSchemas.phone.optional(),
      message: commonSchemas.text(10, 1000),
    }),

    bvHistoryFilter: z.object({
      bvRight: commonSchemas.boolean.optional(),
      bvLeft: commonSchemas.boolean.optional(),
      minBv: commonSchemas.numberString(0).optional(),
      maxBv: commonSchemas.numberString(0).optional(),
      weekNumber: commonSchemas.numberString().optional(),
      date: commonSchemas.date.optional(),
      startDate: commonSchemas.date.optional(),
      endDate: commonSchemas.date.optional(),
      dateRange: z.boolean().optional(),
    }),
  },

  fastCheckout: {
    fastCheckoutForm: z.object({
      referrerAddress: commonSchemas.walletAddress.optional(),
      parentAddress: commonSchemas.walletAddress.optional(),
    }),
  },
};
